import { useViewport as useEtViewport } from "@ever-tutor/et-ui";

export const useViewport = () => {
  return useEtViewport();
};
